import { ChatListOverview } from "@/components/chat-list/chat-list-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/chats/")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.navigation_chats()) }],
	}),
});

function RouteComponent() {
	return <ChatListOverview />;
}
